const fallbackIgnoreErrors = ['AbortError', 'NotAllowedError', 'Network Error'];

export default async function () {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 2000);

  let ignoreErrors = fallbackIgnoreErrors;

  try {
    const response = await fetch('https://static.delfi.lt/portal/ignoreErrors.json', { signal: controller.signal });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const rules = await response.json();

    if (!Array.isArray(rules)) {
      throw new Error('Expected an array of error filters');
    }

    ignoreErrors = rules.map((rule) => {
      if (typeof rule === 'string') {
        return rule;
      }

      if (rule && typeof rule.pattern === 'string') {
        return new RegExp(rule.pattern, rule.flags || '');
      }

      throw new Error('Invalid error filter');
    });
  } catch {
    // Keep fallback filters if fetching or parsing fails
  } finally {
    clearTimeout(timeout);
  }

  return {
    allowUrls: [/https?:\/\/([a-z0-9]*\.)?(?:delfi|dcdn)\.(?:ee|net|lv|lt)/],
    denyUrls: [/g\.delfi\.lt\/scms/, /g\.delfi\.lt\/misc\/rembi/],
    ignoreErrors,
  };
}
